export default {
  name: 'knowledge',
  translationKey: 'knowledge-module',
  routePrefix: 'knowledge',
  routeNamePrefix: 'knowledge',
  directRoutesAvailable: true,
}
